import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/layoutActions";
import * as beads from "../../../actions/beadActions";

import OverzichtForm from "./overzichtForm";
import OverzichtPageHelper from "./overzichtPageHelper";

class OverzichtPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.pageHelper = new OverzichtPageHelper(this);
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {
        this.pageHelper.init();
    }


    componentWillUnmount() {
        this.pageHelper.handleOnStopInterval();
    }

    handleOnGenerateRapport() {
        this.pageHelper.generateRapport();
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        return (<OverzichtForm
            color={types.COLOR_PINK_LIGHT}
            model={this.state.financieelOverzicht}
            documenten={this.state.documenten}
            generateRapport={this.handleOnGenerateRapport}
            isPollingDocument={this.state.timer ? true : false}
        />);
    }
}

OverzichtPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;

    return {
        dossierId: dossierId,
        okiTypes: state.referentie.typeOpbrengstKostInvesteringen
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadFinancieelPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(OverzichtPage));